import { isCustomerFeatureEnabled } from 'src/data/customer';
import { BE_CUSTOMER_FEATURES } from 'src/lib/featureFlags';
// @ts-expect-error - useCurrentCustomer has no TypeScript declarations
import { useCurrentCustomer } from 'src/store/customer';

export const useCustomerPerformanceInsightsEnabled = (): boolean => {
  const customer = useCurrentCustomer();

  return isCustomerFeatureEnabled(customer, BE_CUSTOMER_FEATURES.performanceInsights);
};
